import React, { useState, useEffect } from "react";
import * as S from "./styles";
import city from "../../services/city";
import _, { initial } from "lodash";
import InputText from "../../components/InputText";
import { toast } from "react-toastify";

const InputSearch = ({
  handleSearch,
  initialValue,
  label = "Cidade:",
  type = "PERSON",
}) => {
  const [filtredValue, setFiltredValue] = useState("");

  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);

  const handleOpen = () => {
    setOpen(!open);
  };

  const filterCity = async (value) => {
    try {
      const data = await city.searchCity(value, type);
      if (data?.data) {
        setItems(data?.data?.content || []);
      }
    } catch (err) {
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao buscar dados da cidade!");
      }
    }
  };

  const selection = (item) => {
    handleSearch(item);
    setFiltredValue(item?.descricao || item?.nome);
    setOpen(!open);
  };

  function handleFilter(e) {
    setFiltredValue(e.target.value);
    filterCity(e.target.value);

    if (e && e.target.value.length > 0) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }

  useEffect(() => {
    if (initialValue) {
      setFiltredValue(initialValue?.descricao);
      handleSearch(initialValue);
    } else {
      handleSearch(null);
    }
  }, [initialValue]);

  useEffect(() => {
    filterCity("");
  }, []);

  return (
    <>
      <S.Wrapper>
        <S.Main>
          <S.Select onClick={handleOpen}>
            <InputText
              type="text"
              width="100%"
              label={label}
              onChange={(e) => handleFilter(e)}
              value={filtredValue}
              currency=""
            />
          </S.Select>
          {open && (
            <S.Options>
              {items?.map((item) => (
                <S.Option key={item.id} onClick={() => selection(item)}>
                  <S.Description>
                    {item?.descricao || item?.nome} -{" "}
                    {item?.estado?.nome || item?.uf}
                  </S.Description>
                </S.Option>
              ))}
            </S.Options>
          )}
        </S.Main>
      </S.Wrapper>
    </>
  );
};

export default InputSearch;
